/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getBtsDataActions, {
    getBtsDataTypes,
} from '../../../redux/donneesBts/getBtsData'
import { Get } from '../../../serveur/axios'

function* getBtsDataSagas({ response }) {
    const {
        gouvernorat,
        delegation,
        year,
        yearSecondary,
        secteurbts,
        level,
        gender,
        natureprojet,
        page,
    } = response

    let url = '/editique/BTS/csv?'
    if (gouvernorat) {
        url = `${url}&gouvernorat=${gouvernorat}`
    }
    if (delegation) {
        url = `${url}&delegation=${delegation}`
    }
    if (year) {
        url = `${url}&year=${year}`
    }
    if (yearSecondary) {
        url = `${url}&yearSecondary=${yearSecondary}`
    }
    if (secteurbts) {
        url = `${url}&secteurbts=${secteurbts}`
    }
    if (level) {
        url = `${url}&level=${level}`
    }
    if (gender) {
        url = `${url}&gender=${gender}`
    }
    if (natureprojet) {
        url = `${url}&natureprojet=${natureprojet}`
    }
    if (page) {
        url = `${url}&page=${page}`
    }
    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(getBtsDataActions.getBtsDataSuccess(res.data.data)),
            ])
        } else {
            yield put(getBtsDataActions.getBtsDataFailure(res.data.data))
        }
    } catch (error) {
        yield put(getBtsDataActions.getBtsDataFailure(error))
    }
}

export function* getBtsDataSaga() {
    yield takeLatest(getBtsDataTypes.GET_BTS_DATA_REQUEST, getBtsDataSagas)
}
